import { createRouter, createWebHistory } from 'vue-router'

import Home from '@/views/Home.vue'
import Login from '@/views/auth/Login.vue'

import AuthService from '@/services/auth.service.js'
import UserService from '@/services/user.service.js'
import LinkExterno from '@/components/template/LinkExterno.vue'
import Painel from '@/components/template/Painel.vue'
import ErroLogin from '@/views/auth/Error.vue'

// APPS
import Boletos from '@/views/boletos/Boletos.vue'
import ExtratoFinanceiro from '@/views/financeiro/extrato/ExtratoController.vue'

// CENTRAL DO ALUNO
import CentralAluno from '@/views/centralaluno/CentralDoAluno.vue'
// import PerfilAluno from '@/views/centralaluno/Perfil'
import DocumentosMatricula from '@/views/centralaluno/Documentos.vue'

//ADMINSTRATIVO 
import Administrativo from '@/views/administrativo/Administrativo.vue'
import Colaboradores from '@/views/administrativo/colaboradores/Colaboradores.vue'
import Modulos from '@/views/administrativo/modulos/Modulos.vue'
import Permissoes from '@/views/administrativo/permissoes/Permissoes.vue'
import EstruturaOrganizacional from '@/views/administrativo/estrutura-organizacional/Index.vue'
import Docs from '@/views/administrativo/docs/Docs.vue'
import Unidades from '@/views/administrativo/unidades/Unidades.vue'
import UnidadeForm from '@/views/administrativo/unidades/UnidadeForm.vue'
import Pessoas from '@/views/administrativo/pessoas/Pessoas.vue'
import PessoaDetalhe from '@/views/administrativo/pessoas/PessoaDetalhe.vue'

// LOJA
import Loja from '@/views/loja/Home.vue'
import BuscaLoja from '@/views/loja/Busca.vue'
import Produto from '@/views/loja/Produto.vue'
import Checkout from '@/views/loja/checkout/Checkout.vue'
import Categoria from '@/views/loja/Categoria.vue'
import MinhaConta from '@/views/loja/minhaconta/MinhaConta.vue'

// MARKETPLACE (GESTÃO)
import Marketplace from '@/views/marketplace/Marketplace.vue'
import Descontos from '@/views/marketplace/Descontos.vue'
import Recompra from '@/views/marketplace/Recompra.vue'
import Produtos from '@/views/marketplace/Produtos.vue'
import Categorias from '@/views/marketplace/Categorias.vue'
import Vendas from '@/views/marketplace/Vendas.vue'
import Pedidos from '@/views/marketplace/Pedidos.vue'
import PedidosSeller from '@/views/marketplace/seller/PedidosSeller.vue'
import ListaEntrega from '@/views/marketplace/ListaEntrega.vue'
import EntregarPedido from '@/views/marketplace/EntregarPedido.vue'
import ImprimirEtiquetas from '@/components/marketplace/seller/Etiquetas.vue'
import CancelamentoEstorno from '@/views/marketplace/cancelamento/CancelamentoEstorno.vue'
import EtiquetaCancelamentoMP from '@/views/marketplace/cancelamento/EtiquetaCancelamento.vue'

// PARAMETRIZAÇÃO SHOP
import ParametrizacaoShop from '@/views/marketplace/parametrizacao/Parametrizacao.vue'

// FORMULÁRIOS 2.0
import NpsCampanhas from '@/views/formularios/nps/Campanhas.vue'
import NpsResposta from '@/views/formularios/nps/Resposta.vue'

//MATRICULAS
import Matriculas from '@/views/matriculas/Matriculas.vue'
// import CriarMatricula from '@/views/matriculas/matriculas/Matricula.vue'
import Matricula from '@/views/matriculas/matriculas/MatriculaController.vue'
// import AutoMatricula from '@/views/matriculas/AutoMatricula.vue'
import AutoMatricula from '@/views/matriculas/matriculas/AutoMatricula.vue'
import AppRematricula from '@/views/matriculas/AppRema.vue'
import PropostasRematricula from '@/views/matriculas/propostasrema/PropostasRematricula.vue'
import ListaMatriculas from '@/views/matriculas/matriculas/PrintList.vue'
import SimuladorPrecos from '@/views/matriculas/simulador/SimuladorPrecos.vue'
import PropostaValores from '@/views/matriculas/simulador/PropostaValores.vue'
import MatriculaPublica from '@/views/matriculas/MatriculaPublica.vue'
import MatriculaTracking from '@/views/matriculas/tracking/MatriculaTracking.vue'
import EnrollmentImport from '@/views/matriculas/importacao/EnrollmentImport.vue'
import CollaboratorImport from '@/views/matriculas/importacao/CollaboratorImport.vue'
import MatriculasV2Embed from '@/views/matriculas-v2/MatriculasV2Embed.vue'
import MatriculasV2Handoff from '@/views/matriculas-v2/MatriculasV2Handoff.vue'

//FUNIL DE CAPTAÇÃO
import Captacao from '@/views/captacao/Captacao.vue'
import CaptacaoLeads from '@/views/captacao/leads/Leads.vue'
import GatilhosPipedrive from '@/views/captacao/parametrizacao/GatilhosPipedrive'

// FERRAMENTAS
import Ferramentas from '@/views/ferramentas/Ferramentas'
import FerramentasGatilhos from '@/views/ferramentas/gatilhos/Gatilhos'
import JarvisEmbed from '@/views/jarvis/JarvisEmbed.vue'
import FerramentasIndicadores from '@/views/ferramentas/indicadores/Indicadores'
import RestauracaoBase from '@/views/ferramentas/base/Restauracao'
import OnlineUsers from '@/views/ferramentas/onlineUsers/OnlineUsers.vue'
import RedeChat from '@/components/ferramentas/redechat/views/RedeChatView.vue'
import Assistentes from '@/views/ferramentas/assistentes/Assistentes.vue'
import Alfred from '@/views/ferramentas/alfred/Alfred.vue'

// ALUNOS
import Alunos from '@/views/alunos/Alunos'
import SenhaEmail from '@/views/alunos/senhaEmail/SenhaEmail'
import Carteirinha from '@/views/alunos/carteirinha/Carteirinha.vue'

// FINANCEIRO
import Financeiro from '@/views/financeiro/Financeiro'
import PlanilhasFinanceiro from '@/views/financeiro/planilhas/PlanilhasFinanceiro'
import ConciliacaoRede from '@/views/financeiro/conciliacao/ConciliacaoRede.vue'
import Parametros from '@/views/financeiro/parametros/Parametros'
import AlcadaDescontos from '@/views/financeiro/alcada/AlcadaDescontos'
import PlanosPagamento from '@/views/financeiro/planospagamento/PlanosPagamento'
import Bloqueados from '@/views/financeiro/bloqueados/Bloqueados'
import ModelagemPrecos from '@/views/financeiro/modelagemPrecos/ModelagemPrecos.vue'
import ModelagemReajustes from '@/views/financeiro/modelagemReajustes/ModelagemReajustes.vue'
import DeclaracaoIR from '@/views/financeiro/declaracaoIR/DeclaracaoIR.vue'

// SOLUÇÕES ESCOLARES
import SolucoesEscolares from '@/views/solucoesescolares/SolucoesEscolares'
import PlanilhasSolucoes from '@/views/solucoesescolares/planilhas/PlanilhasSolucoes'
import Estudai from '@/views/solucoesescolares/estudai/Estudai'
import PromptsEstudai from '@/views/solucoesescolares/estudai/Prompts'

// ESTRUTURA ACADEMICA
import EstruturaAcademica from '@/views/estruturaacademica/EstruturaAcademica'
import Turmas from '@/views/estruturaacademica/turmas/Turmas'
import ProgressaoPeriodo from '@/views/estruturaacademica/progressao/ProgressaoPeriodo'
import ProximaTurma from '@/views/estruturaacademica/progressao/ProximaTurma'
import Series from '@/views/estruturaacademica/series/Series'
import DocumentosRequeridos from '@/views/estruturaacademica/documentos/Documentos'
import Locais from '@/views/estruturaacademica/locais/Locais.vue'

// ATIVIDADES
import Atividades from '@/views/atividades/Atividades.vue'
import PlanilhasAtividades from '@/views/atividades/Planilhas.vue'
import AtividadesV2Embed from '@/views/atividades-v2/AtividadesV2Embed.vue'
import NivvoEmbed from '@/views/nivvo/NivvoEmbed.vue'
import NivvoPublicGantt from '@/views/nivvo/NivvoPublicGantt.vue'

//ATENDIMENTO - CHATBOT
// import Chatbot from '@/views/chatbot/Chatbot.vue'
// import FaleComAne from '@/views/chatbot/falecomane/FaleComAne.vue'
// import Conversas from '@/views/chatbot/falecomane/Conversas.vue'

//AGENDA EDU
import AgendaEdu from '@/views/agendaedu/AgendaEdu.vue'
import AgendaEduCanais from '@/views/agendaedu/canais/Canais.vue'

//PLANEJAMENTO DE VENDAS
import PlanejamentoVendas from '@/views/planejamentovendas/PlanejamentoVendas.vue'
import PlanilhasPv from '@/views/planejamentovendas/PlanilhasPv/PlanilhasPv.vue'
import DescontosAlunos from '@/views/planejamentovendas/DescontosAlunos/DescontosAlunos.vue'

//RENEGOCIAÇÃO
import Renegociacao from '@/views/financeiro/renegociacao/Renegociacao.vue' //antigo
import NegocieJa from '@/views/financeiro/negocieja/NegocieJa.vue'
import AppNegocie from '@/views/financeiro/negocieja/app/AppNegocie.vue'
import PoliticasNegociacao from '@/views/financeiro/negocieja/negociacao/PoliticasNegociacao.vue'
import CampanhasNegociacao from '@/views/financeiro/negocieja/negociacao/Campanhas.vue'
import FormasPagamento from '@/views/financeiro/negocieja/negociacao/FormasPagamento.vue'
import NegociarJa from '@/views/financeiro/negocieja/negociacao/NegociarJa.vue'
import Publicos from '@/views/financeiro/negocieja/negociacao/Publicos.vue'

// OUTROS
import sorteio from '@/views/sorteio/sorteio.vue'
import Forbidden from '@/views/forbidden/Forbidden.vue'
import Manutencao from '@/views/manutencao/Manutencao.vue'
// import LojaManutencao from '@/views/manutencao/LojaEmManutencao.vue'

//TECNOLOGIA
import DashboardProjetos from '@/views/tecnologia/DashboardProjetos.vue'
import Lab from '@/views/tecnologia/Lab.vue'
import EngineeringCopilot from '@/views/tecnologia/EngineeringCopilot.vue'
import Poc from '@/views/poc/Poc.vue'
import Precificacao from '@/views/poc/precificacao/Precificacao.vue'
import Vouchers from '@/views/financeiro/vouchers/Vouchers.vue'
import AjustesCadastrais from '@/views/centralfamilia/AjustesCadastrais.vue'


import { useGtag, trackRouter } from "vue-gtag-next"
import NegociacoesEfetivadas from '@/views/financeiro/negocieja/negociacao/NegociacoesEfetivadas.vue'
import Indicacao from '@/views/embaixadores/Indicacao.vue'
import Embaixadores from '@/views/embaixadores/Embaixadores.vue'

// APPSCRIPTS IMPORTADOS
import SguDashboard from '@/views/appscripts/sgu/SguDashboard.vue'
import SguWizard from '@/views/appscripts/sgu/SguWizard.vue'
import SguResponses from '@/views/appscripts/sgu/SguResponses.vue'
import SguReport from '@/views/appscripts/sgu/SguReport.vue'
import SguParameterization from '@/views/appscripts/sgu/SguParameterization.vue'
import ForumDeliberacaoDashboard from '@/views/appscripts/forum-deliberacao/ForumDeliberacaoOfficialDashboard.vue'
import CatalogoRubricas from '@/views/appscripts/CatalogoRubricas.vue'
import DiscountDecisionKanban from '@/views/appscripts/discount-decisions/DiscountDecisionKanban.vue'
import DiscountDecisionDashboard from '@/views/appscripts/discount-decisions/DiscountDecisionDashboard.vue'
import DiscountDecisionParameters from '@/views/appscripts/discount-decisions/DiscountDecisionParameters.vue'

const routes = [
  {
    path: '/matriculas/crm-rematricula',
    name: 'CRM de Rematrícula',
    component: () => import('@/views/crm-rematricula/CrmRematricula.vue'),
    beforeEnter: () => ['visualizarCrmRematricula', 'operarCrmRematricula', 'configurarCrmRematricula'].some(p => UserService.filterPermissions(p)) ? true : { name: 'Sem Permissão' },
    meta: { title: 'Apollo - CRM de Rematrícula', requiresAuth: true },
    permissions: ['visualizarCrmRematricula', 'operarCrmRematricula', 'configurarCrmRematricula']
  },
  {
    path: '/appscripts/mesa-decisao-descontos',
    name: 'Mesa de Decisão de Descontos',
    component: DiscountDecisionKanban,
    beforeEnter: () => [
      'avaliarMesaDecisaoDescontos',
      'visualizarMesaDecisaoDescontos',
      'gerenciarMesaDecisaoDescontos'
    ].some(permission => UserService.filterPermissions(permission))
      ? true
      : { name: 'Sem Permissão' },
    meta: {
      title: 'Apollo - Mesa de Decisão de Descontos',
      requiresAuth: true
    },
    permissions: [
      'avaliarMesaDecisaoDescontos',
      'visualizarMesaDecisaoDescontos',
      'gerenciarMesaDecisaoDescontos'
    ]
  },
  {
    path: '/appscripts/mesa-decisao-descontos/parametros',
    name: 'Parâmetros da Mesa de Descontos',
    component: DiscountDecisionParameters,
    beforeEnter: () => UserService.filterPermissions('gerenciarMesaDecisaoDescontos')
      ? true
      : { name: 'Sem Permissão' },
    meta: {
      title: 'Apollo - Parâmetros da Mesa de Descontos',
      requiresAuth: true
    },
    permissions: ['gerenciarMesaDecisaoDescontos']
  },
  {
    path: '/appscripts/mesa-decisao-descontos/:requestId',
    name: 'Mesa de Decisão - Solicitação',
    component: DiscountDecisionDashboard,
    beforeEnter: () => UserService.filterPermissions('avaliarMesaDecisaoDescontos')
      ? true
      : { name: 'Sem Permissão' },
    meta: {
      title: 'Apollo - Decisão da Solicitação de Desconto',
      requiresAuth: true
    },
    permissions: ['avaliarMesaDecisaoDescontos']
  },
  {
    path: '/appscripts/sgu',
    name: 'SGU - Camadas de Performance',
    component: SguDashboard,
    beforeEnter: () => UserService.filterPermissions('preencherAvaliacaoSgu') || UserService.filterPermissions('preencherAvaliacaoSguCsc')
      ? { path: '/appscripts/sgu/parametrizacao' }
      : true,
    meta: {
      title: 'Apollo - SGU Camadas de Performance',
      requiresAuth: true
    },
    permissions: false
  },
  {
    path: '/appscripts/sgu/dashboard',
    name: 'SGU - Dashboard',
    component: SguDashboard,
    beforeEnter: () => UserService.filterPermissions('Dashboard SGU')
      ? true
      : { name: 'Sem Permissão' },
    meta: {
      title: 'Apollo - Dashboard do SGU',
      requiresAuth: true
    },
    permissions: ['Dashboard SGU']
  },
  {
    path: '/appscripts/sgu/wizard',
    name: 'SGU - Autoavaliacao da Unidade',
    component: SguWizard,
    props: { mode: 'director' },
    beforeEnter: () => UserService.filterPermissions('preencherAvaliacaoSgu')
      ? true
      : { name: 'Sem Permissão' },
    meta: {
      title: 'Apollo - Avaliacao SGU',
      requiresAuth: true
    },
    permissions: ['preencherAvaliacaoSgu']
  },
  {
    path: '/appscripts/sgu/avaliacao-csc',
    name: 'SGU - Avaliacao CSC',
    component: SguWizard,
    props: { mode: 'csc' },
    beforeEnter: () => UserService.filterPermissions('preencherAvaliacaoSguCsc')
      ? true
      : { name: 'Sem Permissão' },
    meta: {
      title: 'Apollo - Avaliação CSC do SGU',
      requiresAuth: true
    },
    permissions: ['preencherAvaliacaoSguCsc']
  },
  {
    path: '/appscripts/sgu/respostas',
    name: 'SGU - Respostas',
    component: SguResponses,
    beforeEnter: () => UserService.filterPermissions('visualizarRespostasSgu')
      ? true
      : { name: 'Sem Permissão' },
    meta: {
      title: 'Apollo - Respostas do SGU',
      requiresAuth: true
    },
    permissions: ['visualizarRespostasSgu']
  },
  {
    path: '/appscripts/sgu/relatorio/:unitId?',
    name: 'SGU - Relatório da Unidade',
    component: SguReport,
    beforeEnter: () => [
      'visualizarRespostasSgu',
      'preencherAvaliacaoSgu'
    ].some(permission => UserService.filterPermissions(permission))
      ? true
      : { name: 'Sem Permissão' },
    meta: {
      title: 'Apollo - Relatório do SGU',
      requiresAuth: true,
      preserveRootView: true
    },
    permissions: ['visualizarRespostasSgu', 'preencherAvaliacaoSgu']
  },
  {
    path: '/appscripts/sgu/parametrizacao',
    name: 'SGU - Parametrizacao',
    component: SguParameterization,
    meta: {
      title: 'Apollo - Parametrização do SGU',
      requiresAuth: true
    }
  },
  {
    path: '/appscripts/forum-deliberacao',
    name: 'Forum de Deliberacao',
    component: ForumDeliberacaoDashboard,
    meta: {
      title: 'Apollo - Forum de Deliberacao',
      requiresAuth: true
    },
    permissions: false
  },
  {
    path: '/appscripts/catalogo-rubricas',
    name: 'Catálogo de Categorias e Rubricas',
    component: CatalogoRubricas,
    meta: {
      title: 'Apollo - Catálogo de Categorias e Rubricas',
      requiresAuth: true
    },
    permissions: false
  },
  {
    path: '/central-familia/ajustes-cadastrais',
    name: 'Ajustes Cadastrais',
    component: AjustesCadastrais,
    meta: {
      title: 'Central da Família - Ajustes Cadastrais',
      requiresAuth: true
    },
    permissions: false
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'Rede Decisão - Apollo',
      requiresAuth: true
    },
    permissions: false
  },
  {
    path: '/redechat',
    name: 'Rede Chat',
    component: RedeChat,
    meta: {
      title: 'Rede Decisão - Rede Chat',
      requiresAuth: true
    },
    permissions: false
  },
  {
    path: '/linkexterno/:id/:isMetabase?/:isUrl?/',
    name: 'LinkExterno',
    component: LinkExterno,
    props: true,
    meta: {
      title: 'Rede Decisão - Link Externo',
      requiresAuth: true
    },
    permissions: [

    ]
  },
  {
    path: '/painel/:id/:hash?',
    name: 'Painel',
    component: Painel,
    props: route => ({
      id: route.params.id,
      hash: route.params.hash,
      path: route.query.path
    }),
    meta: {
      title: 'Rede Decisão - Painel',
      requiresAuth: true
    }
  },
  {
    path: '/renegociacao/',
    name: 'Renegociação',
    component: Renegociacao,
    props: true,
    meta: {
      title: 'Rede Decisão - Negocie Já',
      requiresAuth: true,
      nonColab: true
    }
  },
  {
    path: '/login/:section?',
    name: 'Login',
    component: Login,
    props: true,
    meta: {
      title: 'Rede Decisão - Entrar',
      requiresAuth: false,
      preserveRootView: true
    },
  },
  {
    path: '/centraldoaluno/:idAluno/:idPessoa/:action?',
    name: 'Central do Aluno',
    component: CentralAluno,
    props: true,
    meta: {
      title: 'Rede Decisão - Aluno',
      requiresAuth: true
    },
    permissions: false
  },
  {
    path: '/centraldoaluno/documentos/:id',
    name: 'DocumentosMatricula',
    component: DocumentosMatricula,
    props: true,
    meta: {
      title: 'Rede Decisão - Documentos Matrícula',
      requiresAuth: true
    },
    permissions: false
  },
  {
    path: '/docs/',
    name: 'Docs',
    component: Docs,
    meta: {
      title: 'Rede Decisão - Documentos',
      requiresAuth: true
    },
    permissions: [

    ]
  },
  {
    path: '/loja/',
    name: 'Loja',
    component: Loja,
    meta: {
      requiresAuth: true,
      title: 'Rede Decisão - Shop Decisão',
      nonColab: true
    },
    permissions: false
  },
  {
    path: '/loja/busca/:level/:filter/:query',
    name: 'Busca Loja',
    component: BuscaLoja,
    props: true,
    meta: {
      requiresAuth: true,
      title: 'Rede Decisão - Shop Decisão - Busca',
      nonColab: true
    },
    permissions: false
  },
  {
    path: '/loja/produto/:item/:tipo/:extra?',
    name: 'Produto',
    component: Produto,
    props: true,
    meta: {
      requiresAuth: true,
      title: 'Rede Decisão - Shop Decisão - Produto',
      nonColab: true
    },
    permissions: false
  },
  {
    path: '/loja/checkout/:stepLabel?',
    name: 'Checkout',
    component: Checkout,
    props: true,
    meta: {
      requiresAuth: true,
      title: 'Rede Decisão - Shop Decisão - Checkout',
      nonColab: true,
      preserveRootView: true
    },
    permissions: false
  },
  {
    path: '/minhaconta/:section?/:item?/:detail?',
    name: 'Minha Conta',
    component: MinhaConta,
    props: true,
    meta: {
      requiresAuth: true,
      title: 'Rede Decisão - Shop Decisão - Minha Conta',
      nonColab: true,
      preserveRootView: true
    },
    permissions: false
  },
  {
    path: '/loja/categoria/:idCategoria/:nome',
    name: 'Categoria',
    component: Categoria,
    props: true,
    meta: {
      requiresAuth: true,
      title: 'Rede Decisão - Shop Decisão - Categoria',
      nonColab: true
    },
    permissions: false
  },
  {
    path: '/marketplace',
    component: Marketplace,
    name: 'Marketplace',
    children: [
      {
        path: 'descontos/:target?/:descontoId?',
        name: 'Descontos',
        component: Descontos,
        props: true,
        meta: {
          title: 'Rede Decisão - Marketplace - Descontos',
          requiresAuth: true,
          preserveRootView: true
        },
        permissions: [

        ]
      },
      {
        path: 'recompra/:checkoutId?',
        name: 'Recompra',
        component: Recompra,
        props: true,
        meta: {
          title: 'Rede Decisão - Marketplace - Recompra',
          requiresAuth: true,
          preserveRootView: true
        },
        permissions: [

        ]
      },
      {
        path: 'produtos/:paramId?',
        name: 'Produtos',
        component: Produtos,
        props: true,
        meta: {
          title: 'Rede Decisão - Marketplace - Produtos',
          requiresAuth: true
        },
        permissions: [

        ]
      },
      {
        path: 'categorias/',
        name: 'Categorias',
        component: Categorias,
        props: true,
        meta: {
          title: 'Rede Decisão - Marketplace - Categorias',
          requiresAuth: true
        },
        permissions: [

        ]
      },
      {
        path: 'vendas/:idVendaMaterial?',
        name: 'Vendas e Transações',
        component: Vendas,
        props: true,
        meta: {
          title: 'Rede Decisão - Marketplace - Vendas e Transações',
          requiresAuth: true
        },
        permissions: [

        ]
      },
      {
        path: 'vendas-legado/:idVendaMaterial?',
        name: 'Vendas e Transações Legado',
        component: Vendas,
        props: true,
        meta: {
          title: 'Rede Decisão - Marketplace - Vendas e Transações Legado',
          requiresAuth: true
        },
        permissions: [

        ]
      },
      {
        path: '/marketplace/pedidos/:idPedido?',
        name: 'Pedidos',
        component: Pedidos,
        props: true,
        meta: {
          title: 'Rede Decisão - Marketplace - Pedidos',
          requiresAuth: true
        },
        permissions: [

        ]
      },
      {
        path: '/marketplace/pedidos-legado/:idPedido?',
        name: 'Pedidos Legado',
        component: Pedidos,
        props: true,
        meta: {
          title: 'Rede Decisão - Marketplace - Pedidos Legado',
          requiresAuth: true
        },
        permissions: [

        ]
      },
      {
        path: 'lista-entrega',
        name: 'Lista Entrega',
        component: ListaEntrega,
        props: true,
        meta: {
          title: 'Rede Decisão - Marketplace - Lista de Entrega de Pedidos',
          requiresAuth: true,
          nonColab: true
        }
      },
      {
        path: 'entregar-pedido/:idPedido',
        name: 'entregar_pedido',
        component: EntregarPedido,
        props: true,
        meta: {
          title: 'Rede Decisão - Marketplace - Lista de Entrega de Pedidos',
          requiresAuth: true,
        },
      },
      {
        path: 'imprimir-etiquetas-pedidos',
        name: 'imprimir-etiqueta-pedido',
        component: ImprimirEtiquetas,
        props: true,
        meta: {
          title: 'Rede Decisão - Marketplace - Lista de Entrega de Pedidos',
          requiresAuth: true,
          nonColab: true
        }
      },
      {
        path: 'parametrizacao/:section?/:action?/:mid?/:target?',
        name: 'Parametrização Shop',
        component: ParametrizacaoShop,
        props: true,
        meta: {
          title: 'Rede Decisão - Marketplace - Parametrização',
          requiresAuth: true,
          preserveRootView: true
        },
        permissions: [

        ]
      },
      {
        path: 'cancelamento/:section?',
        name: 'Cancelamento e Estorno',
        component: CancelamentoEstorno,
        props: true,
        meta: {
          title: 'Rede Decisão - Marketplace - Cancelamento e Estorno',
          requiresAuth: true,
          preserveRootView: true
        },
        permissions: [

        ]
      }
    ]
  },
  {
    path: '/nps',
    name: 'NPS',
    component: NpsCampanhas,
    props: true,
    meta: {
      title: 'Rede Decisão - NPS - Campanhas',
      requiresAuth: true
    },
    permissions: [

    ]
  },
  {
    path: '/nps/resposta',
    name: 'NPS',
    component: NpsResposta,
    props: true,
    meta: {
      title: 'Rede Decisão - NPS',
      nonColab: true,
      preserveRootView: true
    },
    permissions: [

    ]
  },
  {
    path: '/boletos',
    name: 'Boletos',
    component: Boletos,
    props: true,
    meta: {
      title: 'Rede Decisão - Boletos',
      nonColab: true,
      requiresAuth: true
    },
    permissions: [

    ]
  },
  {
    path: '/matriculas',
    component: Matriculas,
    name: 'Matriculas',
    children: [
      {
        path: 'pesquisa/:action?',
        name: 'Pesquisa Matriculas',
        component: MatriculasV2Embed,
        props: true,
        meta: {
          title: 'Rede Decisão - Matrículas',
          requiresAuth: true,
          preserveRootView: true
        }
      },
      {
        path: 'propostas-rematricula/:action?',
        component: PropostasRematricula,
        props: true,
        meta: {
          title: 'Propostas Rematrícula',
          requiresAuth: true
        }
      },
      {
        path: 'lista-matriculas',
        name: 'Lista Matrículas',
        component: ListaMatriculas,
        props: true,
        meta: {
          title: 'Rede Decisão - Lista de Matrículas',
          requiresAuth: true
        },
        permissions: [

        ]
      },
      {
        path: 'documentos',
        name: 'Conferência de Documentos',
        component: MatriculasV2Embed,
        props: true,
        meta: {
          title: 'Rede Decisão - Conferência de Documentos',
          requiresAuth: true,
          preserveRootView: true,
          matriculasV2RedirectTo: '/matriculas/documentos'
        }
      },
      {
        path: 'simulador/:idSerie?/:idFuncao?/:tipoMatricula?',
        name: 'Simulador de Preços',
        component: SimuladorPrecos,
        props: true,
        meta: {
          title: 'Rede Decisão - Simulador de Preços',
          requiresAuth: true
        },
      },
      {
        path: 'proposta/',
        name: 'proposta_valores',
        component: PropostaValores,
        props: true,
        meta: {
          title: 'Rede Decisão - Proposta de Valores',
          requiresAuth: true
        },
      },
      {
        path: 'remanejamento/:idMatricula?',
        name: 'Remanejamento',
        component: MatriculasV2Embed,
        props: true,
        meta: {
          title: 'Rede Decisão - Remanejamento',
          requiresAuth: true,
          preserveRootView: true,
          matriculasV2RedirectTo: route => route.params.idMatricula
            ? `/matriculas/remanejamento/${route.params.idMatricula}`
            : '/matriculas/remanejamento'
        }
      },
      {
        path: 'radar-matriculas',
        name: 'Tracking Matrículas',
        component: MatriculaTracking,
        meta: {
          title: 'Rede Decisão - Radar de Matrículas',
          requiresAuth: true
        }
      },
      {
        path: 'importacao-unidades',
        name: 'Importação de Matrículas',
        component: EnrollmentImport,
        beforeEnter: () => UserService.filterPermissions('importarMatriculasUnidades')
          ? true
          : { name: 'Sem Permissão' },
        meta: {
          title: 'Apollo - Importação de Matrículas',
          requiresAuth: true,
          preserveRootView: true
        },
        permissions: ['importarMatriculasUnidades']
      },
      {
        path: 'importacao-colaboradores',
        name: 'Importação de Colaboradores',
        component: CollaboratorImport,
        beforeEnter: () => UserService.filterPermissions('importarColaboradores')
          ? true
          : { name: 'Sem Permissão' },
        meta: {
          title: 'Apollo - Importação de Colaboradores',
          requiresAuth: true,
          preserveRootView: true
        },
        permissions: ['importarColaboradores']
      }
    ]
  },
  {
    path: '/matriculas-v2/:screen?/:idMatricula?',
    name: 'Matrículas V2',
    component: MatriculasV2Handoff,
    props: true,
    meta: {
      title: 'Rede Decisão - Matrículas V2',
      requiresAuth: true
    }
  },
  {
    path: '/matricula/:action?/:step?/:idMatricula?',
    name: 'matricula',
    component: Matricula,
    props: true,
    meta: {
      title: 'Rede Decisão - Nova Matrícula',
      requiresAuth: true,
      preserveRootView: true
    }
  },
  {
    path: '/rematricula/:action?/:step?/:idMatricula?',
    name: 'rematricula',
    component: Matricula,
    props: true,
    meta: {
      title: 'Rede Decisão - Rematrícula',
      requiresAuth: true,
      preserveRootView: true
    }
  },
  {
    path: '/matriculapublica/:idMatricula?/:uuid?',
    name: 'MatriculaPublica',
    component: MatriculaPublica,
    props: true,
    meta: {
      title: 'Rede Decisão - Matrículas - Nova Matrícula Pública',
      nonColab: true,
      requiresAuth: false
    }
  },
  {
    path: '/automatricula/:action?/:step?/:idMatricula?',
    name: 'automatricula',
    component: AutoMatricula,
    props: true,
    meta: {
      title: 'Rede Decisão - Matrículas Autônoma - Nova Matrícula',
      nonColab: true,
      requiresAuth: true,
      preserveRootView: true
    },
  },
  {
    path: '/rematricula/',
    name: 'App Rematrícula',
    component: AppRematricula,
    meta: {
      title: 'Rede Decisão - Matrículas Autônoma - Nova Matrícula',
      nonColab: true,
      requiresAuth: true
    }
  },
  {
    path: '/tecnologia/projetos',
    name: 'Projetos Tecnologia',
    component: DashboardProjetos,
    meta: {
      title: 'Rede Decisão - Projetos Tecnologia',
    }
  },
  {
    path: '/tecnologia/engenharia-copilot',
    name: 'Copiloto de Engenharia',
    component: EngineeringCopilot,
    meta: {
      title: 'Rede Decisão - Copiloto de Engenharia',
      requiresAuth: true,
      permissions: ['gerenciarEngineeringCopilot'],
    }
  },
  {
    path: '/tecnologia/lab',
    name: 'Lab Tecnologia',
    component: Lab,
    meta: {
      title: 'Rede Decisão - Lab Tec',
    }
  },
  {
    path: '/captacao',
    name: 'Captação',
    component: Captacao,
    children: [
      {
        path: 'leads/:action?/:idProspect?',
        component: CaptacaoLeads,
        name: 'Leads',
        props: true,
        meta: {
          title: 'Rede Decisão - Funil de Captação - Formulário de Leads',
          requiresAuth: true,
          preserveRootView: true
        }
      }
    ]
  },
  {
    path: '/captacao/parametrizacao/gatilhos-pipedrive',
    name: 'Gatilhos Pipedrive',
    component: GatilhosPipedrive,
    meta: {
      title: 'Rede Decisão - Funil de Captação - Parametrização - Gatilhos Pipedrive',
      requiresAuth: true
    }
  },
  {
    path: '/ferramentas',
    component: Ferramentas,
    name: 'Ferramentas',
    children: [
      {
        path: 'indicadores',
        component: FerramentasIndicadores,
        props: true,
        meta: {
          title: 'Parametrização Indicadores',
          requiresAuth: true
        }
      },
      {
        path: 'gatilhos/:action?',
        component: FerramentasGatilhos,
        props: true,
        meta: {
          title: 'Parametrização Gatilhos',
          requiresAuth: true
        }
      },
      {
        path: 'jarvis-v2/:pathMatch(.*)*',
        component: JarvisEmbed,
        props: true,
        beforeEnter: () => UserService.filterPermissions('JARVIS')
          ? true
          : { name: 'Sem Permissão' },
        meta: {
          title: 'Jarvis 2.0 - Gatilhos de Intervenção',
          requiresAuth: true,
          preserveRootView: true
        }
      },
      {
        path: 'restauracao-base',
        component: RestauracaoBase,
        meta: {
          title: 'Restauração de Base',
          requiresAuth: true
        }
      },
      {
        path: 'formularios/:action?/:id?',
        component: AtividadesV2Embed,
        name: "Formulários",
        props: true,
        meta: {
          title: 'Formulários',
          requiresAuth: true,
          preserveRootView: true,
          atividadesV2RedirectTo: route => {
            if (route.params.action === 'novo') return '/config/formularios/novo'
            if (route.params.action === 'editar' && route.params.id) return `/config/formularios/${route.params.id}`
            if (route.params.action === 'view' && route.params.id) return `/config/formularios/view/${route.params.id}`
            return '/config/formularios'
          }
        }
      },
      {
        path: 'gatilhos-atividades/:idCategoria?/:idFormulario?/:perfilPessoa?',
        component: AtividadesV2Embed,
        name: "Gatilhos Atividades",
        props: true,
        meta: {
          title: 'Gatilhos Atividades',
          requiresAuth: true,
          preserveRootView: true,
          atividadesV2RedirectTo: '/config/gatilhos'
        }
      },
      {
        path: 'online-users',
        component: OnlineUsers,
        name: "Usuários Online",
        props: true,
        meta: {
          title: 'Usuários Online',
          requiresAuth: true
        }
      },
      {
        path: 'assistentes/:id?',
        component: Assistentes,
        name: "Assistentes",
        props: true,
        meta: {
          title: 'Assistentes',
          requiresAuth: true,
          preserveRootView: true
        }
      },
      {
        path: 'alfred/:id?',
        component: Alfred,
        name: "Alfred",
        props: true,
        meta: {
          title: 'Alfred',
          requiresAuth: true
        }
      },
    ],
    meta: {
      title: 'Rede Decisão - Ferramentas',
      requiresAuth: true
    }
  },
  {
    path: '/estrutura-academica',
    component: EstruturaAcademica,
    name: 'Estrutura Acadêmica',
    children: [
      {
        path: 'turmas/:action?',
        component: Turmas,
        props: true,
        name: 'Estrutura Acadêmica - Turmas',
        meta: {
          title: 'Turmas',
          requiresAuth: true,
          preserveRootView: true
        }
      },
      {
        path: 'progressao-blocked',
        component: ProgressaoPeriodo,
        props: true,
        name: 'Estrutura Acadêmica - Progressão Período',
        meta: {
          title: 'Progressão Período',
          requiresAuth: true
        }
      },
      {
        path: 'proxima-turma',
        component: ProximaTurma,
        props: true,
        name: 'Estrutura Acadêmica - Próxima Turma',
        meta: {
          title: 'Próxima Turma',
          requiresAuth: true
        }
      },
      {
        path: 'series/:action?/:target?',
        component: Series,
        props: true,
        name: 'Estrutura Acadêmica - Séries',
        meta: {
          title: 'Séries',
          requiresAuth: true,
          preserveRootView: true
        }
      },
      {
        path: 'documentos/:action?',
        component: DocumentosRequeridos,
        props: true,
        name: 'Estrutura Acadêmica - Documentos',
        meta: {
          title: 'Documentos',
          requiresAuth: true
        }
      },
      {
        path: 'locais/:idLocal?',
        component: Locais,
        props: true,
        name: 'Locais',
        meta: {
          title: 'Estrutura Acadêmica - Locais',
          requiresAuth: true
        }
      },
    ],
    meta: {
      title: 'Rede Decisão - Estrutura Acadêmica',
      requiresAuth: true
    }
  },
  {
    path: '/alunos',
    component: Alunos,
    name: 'Alunos',
    children: [
      {
        path: 'restaura-senha-email-aluno',
        name: 'Restaura Senha Aluno',
        component: SenhaEmail,
        props: true,
        meta: {
          title: 'Restaurar senha email',
          requiresAuth: true,
          nonColab: true
        }
      },
      {
        path: 'carteirinha/:idPessoa',
        name: 'Carteirinha Aluno',
        component: Carteirinha,
        props: true,
        meta: {
          title: 'Carteirinha Aluno',
          requiresAuth: true,
          nonColab: false
        }
      }
    ],
    meta: {
      title: 'Rede Decisão - Alunos',
      requiresAuth: true
    }
  },
  {
    path: '/pv',
    component: PlanejamentoVendas,
    name: 'Planejamento de Vendas',
    children: [
      {
        path: 'planilhas',
        name: 'Planilhas PV',
        component: PlanilhasPv,
        props: true,
        meta: {
          title: 'Planejamento de Vendas - Planilhas',
          requiresAuth: true,
        }
      },
      {
        path: 'descontos-alunos',
        name: 'Descontos Aluno',
        component: DescontosAlunos,
        props: true,
        meta: {
          title: 'Planejamento de Vendas - Descontos por Aluno',
          requiresAuth: true,
        }
      },
    ]
  },
  {
    path: '/negocieja',
    name: 'negocieja',
    component: NegocieJa,
    children: [
      {
        path: 'appPublic/:session?/:step?/:idProposta?',
        name: 'negociejaAppPublic',
        component: AppNegocie,
        props: true,
        meta: {
          title: 'Rede Decisão - Negocie Já',
          requiresAuth: false,
          nonColab: true,
          preserveRootView: true
        }
      },
      {
        path: 'app/:session?/:step?/:idProposta?',
        name: 'negociejaApp',
        component: AppNegocie,
        props: true,
        meta: {
          title: 'Rede Decisão - Negocie Já',
          requiresAuth: true,
          nonColab: true,
          preserveRootView: true
        }
      },
      {
        path: 'negociacao',
        name: 'negociacaoSelect',
        component: NegociarJa,
        props: true,
        meta: {
          title: 'Rede Decisão - Negocie Já',
          requiresAuth: true,
        }
      },

      {
        path: 'campanhas',
        name: 'negocie_campanhas',
        component: CampanhasNegociacao,
        props: true,
        meta: {
          title: 'Negocie Já - Campanhas',
          requiresAuth: true,
        }
      },
      {
        path: 'politicas',
        component: PoliticasNegociacao,
        name: 'negocie_politicas',
        props: true,
        meta: {
          title: 'Negocie Já - Políticas',
          requiresAuth: true
        }
      },
      {
        path: 'forma-pagamento',
        component: FormasPagamento,
        name: 'forma-pagamento',
        meta: {
          title: 'Negocie Já - Forma de Pagamento',
          requiresAuth: true
        }
      },
      {
        path: 'negociacoes-efetivadas',
        component: NegociacoesEfetivadas,
        name: 'negociacoes-efetivadas',
        meta: {
          title: 'Negocie Já - Negociações',
          requiresAuth: true
        }
      },
      {
        path: 'publicos',
        component: Publicos,
        name: 'publicos',
        meta: {
          title: 'Negocie Já - Públicos',
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: '/financeiro',
    component: Financeiro,
    name: 'Financeiro',
    children: [
      {
        path: 'conciliacao-rede',
        component: ConciliacaoRede,
        name: 'Conciliação Rede / Perseus',
        meta: { title: 'Conciliação Rede / Perseus', requiresAuth: true }
      },
      {
        path: 'planilhas/:action?',
        component: PlanilhasFinanceiro,
        props: true,
        meta: {
          title: 'Planilhas Financeiro',
          requiresAuth: true
        }
      },
      {
        path: 'parametros/:target?',
        component: Parametros,
        name: 'Parâmetros Financeiros',
        props: true,
        meta: {
          title: 'Parâmetros Financeiros',
          requiresAuth: true,
          preserveRootView: true
        }
      },
      {
        path: 'alcada/:action?',
        component: AlcadaDescontos,
        name: 'Alçada de Descontos',
        props: true,
        meta: {
          title: 'Alçada de Descontos',
          requiresAuth: true,
          preserveRootView: true
        }
      },
      {
        path: 'planospagamento/:section?',
        component: PlanosPagamento,
        name: 'Planos de Pagamento',
        props: true,
        meta: {
          title: 'Planos de Pagamento',
          requiresAuth: true
        }
      },
      {
        path: 'bloqueados',
        component: Bloqueados,
        name: 'Bloqueados',
        props: true,
        meta: {
          title: 'Bloqueados',
          requiresAuth: true
        }
      },
      {
        path: 'vouchers/:section?/:id?/:action?/:itemId?',
        component: Vouchers,
        name: 'Vouchers',
        props: true,
        meta: {
          title: 'Vouchers',
          requiresAuth: true,
          preserveRootView: true
        }
      },
      {
        path: 'extrato/:idPessoa?/:declaracao?',
        component: ExtratoFinanceiro,
        name: 'Extrato Financeiro',
        props: true,
        meta: {
          title: 'Ficha Financeiro',
          requiresAuth: true,
          nonColab: true,
          preserveRootView: true
        }
      },
      {
        path: 'modelagem-precos',
        component: ModelagemPrecos,
        name: 'Modelagem de Preços',
        props: true,
        meta: {
          title: 'Modelagem de Preços',
          requiresAuth: true
        }
      },
      {
        path: 'modelagem-reajustes',
        component: ModelagemReajustes,
        name: 'Modelagem de Reajustes',
        props: true,
        meta: {
          title: 'Modelagem de Reajustes',
          requiresAuth: true
        }
      },
      {
        path: 'ir',
        component: DeclaracaoIR,
        name: 'Declaracao IR',
        props: true,
        meta: {
          title: 'Imposto de Renda',
          requiresAuth: true,
          nonColab: true
        }
      }
    ],
    meta: {
      title: 'Rede Decisão - Financeiro',
      requiresAuth: true
    }
  },
  {
    path: '/solucoesescolares',
    component: SolucoesEscolares,
    name: 'Soluções Escolares',
    children: [
      {
        path: 'planilhas/:action?',
        component: PlanilhasSolucoes,
        props: true,
        meta: {
          title: 'Soluções Escolares - Planilhas',
          requiresAuth: true
        }
      },
      {
        path: 'conteudosprogramaticos/:conteudo?/:topico?',
        component: Estudai,
        props: true,
        name: 'Conteúdos Programáticos',
        meta: {
          title: 'Soluções Escolares - Conteúdos Programáticos',
          requiresAuth: true,
          preserveRootView: true
        }
      },
      {
        path: 'prompts/:action?/:prompt?',
        component: PromptsEstudai,
        props: true,
        name: 'Prompts EstudAI',
        meta: {
          title: 'EstudAI - Prompts Conteúdos',
          requiresAuth: true
        }
      }
    ],
    meta: {
      title: 'Rede Decisão - Soluções Escolares',
      requiresAuth: true
    }
  },
  {
    path: '/nivvo/public/projects/:projectId/gantt',
    name: 'Gantt público do Nivvo',
    component: NivvoPublicGantt,
    props: route => ({
      projectId: route.params.projectId,
      expires: route.query.expires,
      signature: route.query.signature
    }),
    meta: {
      title: 'Rede Decisão - Acompanhamento do projeto',
      requiresAuth: false,
      preserveRootView: true
    }
  },
  {
    path: '/nivvo/:pathMatch(.*)*',
    name: 'Nivvo',
    component: NivvoEmbed,
    props: true,
    meta: {
      title: 'Rede Decisão - Nivvo',
      requiresAuth: true,
      preserveRootView: true
    }
  },
  {
    path: '/config/aprovacoes',
    component: AtividadesV2Embed,
    name: 'Aprovações de Atividades',
    meta: {
      title: 'Aprovações de Atividades',
      requiresAuth: true,
      preserveRootView: true,
      atividadesV2RedirectTo: '/config/aprovacoes'
    }
  },
  {
    path: '/atividades',
    component: Atividades,
    name: 'Atividades',
    children: [
      {
        path: 'painel/:section?/:action?/:id?',
        name: 'Painel Atividades',
        component: AtividadesV2Embed,
        props: true,
        meta: {
          title: 'Atividades',
          requiresAuth: true,
          preserveRootView: true,
          atividadesV2RedirectTo: route => {
            const section = route.params.section || 'atendimentos'
            if (route.params.id) return `/activities/${route.params.id}?type=${section}&action=${route.params.action === 'executar' ? 'executar' : 'ver'}`
            if (route.params.action === 'nova') return `/activities/novo?type=${section}`
            return route.query.mode ? `/?type=${section}` : `/?type=${section}&mode=kanban`
          }
        }
      },
      {
        path: 'planilhas',
        component: PlanilhasAtividades,
        props: true,
        meta: {
          title: 'Planilhas Atividades',
          requiresAuth: true
        }
      },
      {
        path: 'importacoes',
        component: AtividadesV2Embed,
        props: true,
        meta: {
          title: 'Importação de Atividades',
          requiresAuth: true,
          preserveRootView: true,
          atividadesV2RedirectTo: '/activities/importacoes'
        }
      },
      {
        path: 'categorias/:action?/:id?',
        component: AtividadesV2Embed,
        props: true,
        meta: {
          title: 'Categorias Atividades',
          requiresAuth: true,
          preserveRootView: true,
          atividadesV2RedirectTo: route => {
            if (route.params.action === 'novo') return '/config/categorias/novo'
            if (route.params.action === 'editar' && route.params.id) return `/config/categorias/${route.params.id}`
            return '/config/categorias'
          }
        }
      },
      {
        path: 'atendimentos/categorias',
        component: AtividadesV2Embed,
        props: true,
        meta: {
          title: 'Categorias Atendimentos',
          requiresAuth: true,
          preserveRootView: true,
          atividadesV2RedirectTo: '/config/categorias?type=atendimentos'
        }
      },
      {
        path: 'pesquisa',
        component: AtividadesV2Embed,
        props: true,
        meta: {
          title: 'Pesquisar Atendimentos',
          requiresAuth: true,
          preserveRootView: true,
          atividadesV2RedirectTo: '/activities/pesquisa-avancada'
        }
      },
      {
        path: 'configuracoes',
        component: AtividadesV2Embed,
        props: true,
        meta: {
          title: 'Configurações de Atividades',
          requiresAuth: true,
          preserveRootView: true,
          atividadesV2RedirectTo: '/config'
        }
      },
      {
        path: 'formularios/:action?/:id?',
        component: AtividadesV2Embed,
        props: true,
        meta: {
          title: 'Formulários',
          requiresAuth: true,
          preserveRootView: true,
          atividadesV2RedirectTo: route => {
            if (route.params.action === 'novo') return '/config/formularios/novo'
            if (route.params.action === 'editar' && route.params.id) return `/config/formularios/${route.params.id}`
            if (route.params.action === 'view' && route.params.id) return `/config/formularios/view/${route.params.id}`
            return '/config/formularios'
          }
        }
      },
      {
        path: 'gatilhos/:action?/:id?',
        component: AtividadesV2Embed,
        props: true,
        meta: {
          title: 'Gatilhos de Atividades',
          requiresAuth: true,
          preserveRootView: true,
          atividadesV2RedirectTo: route => {
            if (route.params.action === 'novo') return '/config/gatilhos/novo'
            if (route.params.action === 'editar' && route.params.id) return `/config/gatilhos/${route.params.id}`
            return '/config/gatilhos'
          }
        }
      },
      {
        path: 'bases/:action?/:id?',
        component: AtividadesV2Embed,
        props: true,
        meta: {
          title: 'Bases de Formulários',
          requiresAuth: true,
          preserveRootView: true,
          atividadesV2RedirectTo: route => {
            if (route.params.action === 'novo') return '/config/bases/novo'
            if (route.params.action === 'editar' && route.params.id) return `/config/bases/${route.params.id}`
            return '/config/bases'
          }
        }
      },
      {
        path: 'fluxos/:action?/:id?',
        component: AtividadesV2Embed,
        props: true,
        meta: {
          title: 'Fluxos de Atividades',
          requiresAuth: true,
          preserveRootView: true,
          atividadesV2RedirectTo: route => {
            if (route.params.action === 'novo') return '/config/fluxos/novo'
            if (route.params.action === 'editar' && route.params.id) return `/config/fluxos/${route.params.id}`
            return '/config/fluxos'
          }
        }
      },
      {
        path: 'macroprocessos/:action?/:id?',
        component: AtividadesV2Embed,
        props: true,
        meta: {
          title: 'Macroprocessos',
          requiresAuth: true,
          preserveRootView: true,
          atividadesV2RedirectTo: route => {
            if (route.params.action === 'novo') return '/config/processos/novo'
            if (route.params.action === 'editar' && route.params.id) return `/config/processos/${route.params.id}`
            if (route.params.action === 'ver' && route.params.id) return `/processos/${route.params.id}`
            return '/processos'
          }
        }
      },
      {
        path: 'respostas/:id?',
        component: AtividadesV2Embed,
        props: true,
        meta: {
          title: 'Respostas de Formulários',
          requiresAuth: true,
          preserveRootView: true,
          atividadesV2RedirectTo: route => route.params.id
            ? `/config/formularios/respostas/${route.params.id}`
            : '/config/formularios/respostas'
        }
      },
      {
        path: 'modulo/:pathMatch(.*)*',
        component: AtividadesV2Embed,
        props: true,
        meta: {
          title: 'Atividades',
          requiresAuth: true,
          preserveRootView: true,
          atividadesV2RedirectTo: route => {
            const path = Array.isArray(route.params.pathMatch) ? route.params.pathMatch.join('/') : route.params.pathMatch
            return path ? `/${path}` : '/'
          }
        }
      }
    ]
  },
  {
    path: '/administrativo',
    component: Administrativo,
    name: 'Administrativo',
    children: [
      {
        path: 'pessoas',
        name: 'Pessoas',
        component: Pessoas,
        meta: {
          title: 'Rede Decisão - Pessoas',
          requiresAuth: true
        },
        permissions: ['gerenciarPessoas']
      },
      {
        path: 'pessoas/:idPessoa',
        name: 'Pessoa',
        component: PessoaDetalhe,
        props: true,
        meta: {
          title: 'Rede Decisão - Pessoa',
          requiresAuth: true
        },
        permissions: ['gerenciarPessoas']
      },
      {
        path: 'colaboradores/:action?/:id?/',
        name: 'colaboradores',
        component: Colaboradores,
        props: true,
        meta: {
          title: 'Colaboradores',
          requiresAuth: true,
          preserveRootView: true
        }
      },
      {
        path: 'modulos',
        name: 'Módulos',
        component: Modulos,
        meta: {
          title: 'Rede Decisão - Módulos',
          requiresAuth: true
        }
      },
      {
        path: 'funcionalidades',
        name: 'Liberação de funcionalidades',
        component: () => import('@/views/administrativo/funcionalidades/FeatureFlags.vue'),
        meta: { title: 'Rede Decisão - Liberação de funcionalidades', requiresAuth: true }
      },
      {
        path: 'permissoes',
        name: 'Permissões',
        component: Permissoes,
        meta: {
          title: 'Rede Decisão - Permissões',
          requiresAuth: true
        }
      },
      {
        path: 'funcoes',
        redirect: { name: 'Estrutura organizacional' }
      },
      {
        path: 'estrutura-organizacional',
        name: 'Estrutura organizacional',
        component: EstruturaOrganizacional,
        beforeEnter: () => (
          UserService.filterPermissions('visualizarEstruturaOrganizacional') ||
          UserService.filterPermissions('gerenciarEstruturaOrganizacional')
        )
          ? true
          : { name: 'Sem Permissão' },
        meta: {
          title: 'Rede Decisão - Estrutura organizacional',
          requiresAuth: true
        },
        permissions: ['visualizarEstruturaOrganizacional']
      },
      {
        path: 'unidades',
        name: 'Unidades',
        component: Unidades,
        meta: {
          title: 'Rede Decisão - Unidades',
          requiresAuth: true
        }
      },
      {
        path: 'unidades/nova',
        name: 'Nova unidade',
        component: UnidadeForm,
        meta: {
          title: 'Rede Decisão - Nova unidade',
          requiresAuth: true
        }
      },
      {
        path: 'unidades/:idUnidade/editar',
        name: 'Editar unidade',
        component: UnidadeForm,
        props: true,
        meta: {
          title: 'Rede Decisão - Editar unidade',
          requiresAuth: true
        }
      },
    ],
    meta: {
      title: 'Rede Decisão - Financeiro',
      requiresAuth: true
    }
  },
  {
    path: '/sorteiocumbuca/',
    name: 'sorteio',
    component: sorteio,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/etiqueta-cancelamento/:solicitacao',
    name: 'Etiqueta Cancelamento',
    component: EtiquetaCancelamentoMP,
    props: true,
    meta: {
      title: "Imprimir Etiqueta de Cancelamento",
      requiresAuth: false,
      nonColab: true,
    }
  },
  {
    path: '/agendaedu',
    component: AgendaEdu,
    name: 'AgendaEdu',
    children: [
      {
        path: 'canais/:action?/:id?',
        component: AgendaEduCanais,
        name: 'AgendaEdu Canais',
        props: true,
        meta: {
          title: 'AgendaEdu - Canais',
          requiresAuth: true,
          preserveRootView: true
        }
      },
    ]
  },
  // {
  //   path: '/atendimento',
  //   component: Chatbot,
  //   name: 'atendimento',
  //   children: [
  //     {
  //       path: 'falecomaane',
  //       component: FaleComAne,
  //       name: 'Fale com a Ane',
  //       props: true,
  //       meta: {
  //         title: 'Fale com a Ane',
  //         requiresAuth: false,
  //         nonColab: true
  //       }
  //     },
  //     {
  //       path: 'conversas/:id?',
  //       component: Conversas,
  //       name: 'Fale com a Ane - Conversas',
  //       props: true,
  //       meta: {
  //         title: 'Fale com a Ane',
  //         requiresAuth: true,
  //         nonColab: false
  //       }
  //     },
  //   ]
  // },
  {
    path: '/erro-login/',
    name: 'Erro Login',
    component: ErroLogin,
    props: true,
    meta: {
      requiresAuth: false,
      nonColab: true,
    }
  },
  {
    path: '/forbidden/',
    name: 'Sem Permissão',
    component: Forbidden,
    props: false,
    meta: {
      requiresAuth: false,
      nonColab: true,
    }
  },
  {
    path: '/manutencao/',
    name: 'Manutenção',
    component: Manutencao,
    props: false,
    meta: {
      requiresAuth: false,
      nonColab: false,
      isMaintenance: true
    }
  },
  {
    path: '/embaixadores',
    name: 'embaixadores',
    component: Embaixadores,
    children: [
      {
        path: 'indicacao',
        name: 'Indicação',
        component: Indicacao,
        props: true,
        meta: {
          title: 'Rede Decisão - Indicação',
          requiresAuth: false,
          nonColab: true
        }
      },
    ]
  },
  {
    path: '/seller/pedidos',
    name: 'PedidosSeller',
    component: PedidosSeller,
    props: true,
    meta: {
      title: 'Rede Decisão - Seller - Pedidos',
      requiresAuth: true,
      nonColab: true
    }
  },
  {
    path: '/poc/',
    name: 'POC',
    component: Poc,
    props: false,
    meta: {
      requiresAuth: false,
      nonColab: false
    },
    children: [
      {
        path: 'precificacao',
        component: Precificacao,
        props: true,
        name: 'POC - Precificação',
        meta: {
          title: 'Turmas',
          requiresAuth: true
        }
      }
    ]
  }
]

const routelist = []

routes.map(k => {
  const item = {
    path: k.path,
    name: k.name,
    meta: k.meta
  }
  routelist.push(item)
})

const router = createRouter({
  mode: 'history',
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {

  const localToken = localStorage.getItem('token')
  const token = to.query.token
  const email = to.query.email
  const aeToken = to.query.aetoken

  var user = localStorage.getItem('profile')
  user = user ? JSON.parse(atob(user)) : null

  const isColab = user?.colaborador
  const isSeller = user?.fornecedor

  setTimeout(() => {
    if (to.meta.title) {
      document.title = to.meta.title
    }
  }, 0)

  let getManutencao = null
  try {
    getManutencao = await AuthService.getConfig()
  } catch (error) {
    console.error('Erro ao carregar configapollo:', error)
  }
  const emManutencao = !!getManutencao?.data?.emManutencao
  const emManutencaoMatriculas = !!getManutencao?.data?.emManutencaoMatriculas
  const currentUser = localStorage.getItem('profile') ? JSON.parse(atob(localStorage.getItem('profile'))) : null
  const depto = currentUser?.colaborador?.idDepartamento

  const rotasMatricula = ['MatriculaPublica', 'matricula', 'rematricula']
  const isRotaMatricula = rotasMatricula.includes(to.name)
  const isRotaManutencao = to.meta?.isMaintenance || to.name == 'Manutenção'

  const manutencaoGeralAtiva = emManutencao && depto != 52
  const manutencaoMatriculasAtiva = emManutencaoMatriculas && isRotaMatricula

  const deveIrParaManutencao = manutencaoGeralAtiva || manutencaoMatriculasAtiva
  const deveFicarNaManutencao = isRotaManutencao && (manutencaoGeralAtiva || emManutencaoMatriculas)

  if (deveFicarNaManutencao) {
    return next()
  }

  if (deveIrParaManutencao) {
    return next({
      name: 'Manutenção',
      replace: true,
      query: to.query
    })
  } else if (isRotaManutencao) {
    return next({ name: 'Home', replace: true, query: to.query })
  }

  if (to.meta.requiresAuth) {
    if (process.env.VUE_APP_TRACKING_LOCAL_BYPASS === 'true' && to.name === 'Tracking Matrículas') {
      if (!localStorage.getItem('token')) localStorage.setItem('token', 'tracking-local-bypass')
      if (!localStorage.getItem('profile')) {
        localStorage.setItem('profile', btoa(JSON.stringify({
          nome: 'Dev Local',
          email: 'dev.local@rededecisao.com.br',
          colaborador: { idUnidade: null }
        })))
      }

      return next()
    }

    if (aeToken) {

      try {
        const loginEdu = await AuthService.loginAgendaEdu(aeToken)
        const userEmail = loginEdu.data.data.attributes.email
        const isSecaoMatricula = to.name == 'matricula' || to.name == 'rematricula' || to.name == 'App Rematrícula'

        if (isSecaoMatricula) {
          const automatriculaUrl = `https://matriculas-prod.rededecisao.com.br/automatricula?email=${encodeURIComponent(userEmail)}&source=automatricula`
          
          window.location.replace(automatriculaUrl)
          return next(false)
        }

        return next({ name: to.name, replace: true, query: { token: process.env.VUE_APP_LARAVEL_API_LOGIN_TOKEN, email: userEmail } })
      } catch (error) {
        return next({ name: 'Login' })
      }
    } else if (token && email) {
      try {
        const login = {
          apiToken: token,
          userEmail: email,
          portal: 'portalGestao'
        }
        await AuthService.loginApi(login)

        const params = to.params ?? {}
        if (to.meta.nonColab) {
          return next({ name: to.name, replace: true, params: params, query: {} })
        } else {
          if (isColab) {
            return next({ name: to.name, replace: true, params: params, query: {} })
          } else {
            return next({ name: 'Loja', replace: true, params: params, query: {} })
          }
        }

      } catch (error) {
        return next({ name: 'Login' })
      }
    } else if (localToken) {
      try {
        await AuthService.verifyLocalToken(localToken)

        if (to.meta.nonColab) {
          return next()
        } else {
          if (isColab) {
            return next()
          } else if (isSeller) {
            return next({ name: 'PedidosSeller', replace: true, query: {} })
          } else {
            if (to.name !== 'Loja') {
              return next({ name: 'Loja', replace: true, query: {} })
            } else {
              return next() // Allow navigation if already on the right route
            }
          }
        }
      } catch (error) {
        return next({ name: 'Login' }); // Redirect to login on error
      }
    } else {
      return next({ name: 'Login' })
    }
  } else {

    return next()
  }
})

router.afterEach((to) => {
  const { pageview, event } = useGtag()

  pageview({
    page_path: to.path,
  })

  event(to.path, {
    'event_category': 'page_view',
    'event_label': to.path
  })
})

trackRouter(router)

export default router
